<template>
  <a-cascader v-model="input" class="searchSelect" v-bind="$attrs" v-on="$listeners" :options="cityDatas" @change="onChange" :placeholder="placeholder">
     <a-icon slot="suffixIcon" type="caret-down" />
     <slot></slot>
  </a-cascader>
</template>

<script>
  export default {
    name: 'ptCascader',
    props:{
      placeholder:{
        type:String,
      },
      cityDatas:{
        type:Array,
      },
      value:{
        type:Array,
      }
    },
    data() {
      return {
        input:this.value
      }
    },
    watch:{
      value (val) {
        this.input = val
      },
    },
    methods:{
      onChange(value){
        this.$emit('input',value)
        this.$emit('changeValue',value);
      }
    }
  }
</script>

<style scoped lang="less">

</style>